import { Component, OnChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { BaseComponent } from '../../shared/base-components/base.component';
import { CustomerImageType } from '../models/enums/customer-image-type.enum';
import { CustomerImageService } from '../shared/customer-image.service';

@Component({
    selector: 'customer-signature',
    templateUrl: './customer-signature.html',
    inputs: ['customerNumberId', 'legacySequenceNumber', 'credentialNumberId', 'imageId', 'imageType', 'classes', 'businessTransactionNumberId']
})
export class CustomerSignatureComponent extends BaseComponent implements OnChanges {

    // Inputs
    public customerNumberId: number;
    public legacySequenceNumber: string;
    public credentialNumberId: number;
    public imageId: string;
    public imageType: CustomerImageType = CustomerImageType.TOP_OF_STACK;
    public classes = 'mvd_photo--sig';
    public businessTransactionNumberId: number;

    // logic
    public signature: any = 'dist/MaxWeb/assets/images/no-signature.svg'; // 'url(dist/MaxWeb/assets/images/no-signature.svg)'
    private fileType = 'png';

    constructor(
        private _imageService: CustomerImageService,
        private _sanitizer: DomSanitizer) {
        super();
    }

    public ngOnInit() {
        // ngOnChanges Fires before ngOnInit
    }

    public ngOnChanges() {
        let observable = this.getObservable(this.imageType);
        if (observable) {
            observable.subscribe(content => {
                if ((null != content) && (null != content.result)) {
                    this.signature = this._sanitizer.bypassSecurityTrustResourceUrl(`data:image/${this.fileType};base64,${content.result}`);
                }
            });
        }
    }

    public getObservable(imageType: CustomerImageType): Observable<{ result: string }> {
        switch (imageType) {
            case CustomerImageType.RECENT: {
                if (this.customerNumberId) {
                    return this._imageService.getRecentSignature(this.customerNumberId);
                }
                break;
            }
            case CustomerImageType.CREDENTIAL: {
                if (this.credentialNumberId) {
                    return this._imageService.getDriverCredentialSignature(this.credentialNumberId);
                }
                break;
            }
            case CustomerImageType.DRIVER_DEFAULT: {
                if (this.imageId) {
                    return this._imageService.getDriverImageSignature(this.imageId);
                }
                break;
            }
            case CustomerImageType.ISSUANCE_TRANSACTION: {
                if (!!this.businessTransactionNumberId) {
                    return this._imageService.getTransactionSignature(this.businessTransactionNumberId);
                }
                break;
            }
            case CustomerImageType.TOP_OF_STACK:
            default: {
                if (this.customerNumberId) {
                    return this._imageService.getDriverTopOfStackSignature(this.customerNumberId);
                }
            }
        }
        return null;
    }
}
